let runtimePromise: Promise<ITips> | undefined;

const ensureLoaderMarker = (id: string): void => {
  if (document.getElementById(id)) return;
  const marker = document.createElement('script');
  marker.id = id;
  marker.type = 'application/json';
  document.head.appendChild(marker);
};

/**
 * Vditorが通常CDNから動的取得する必須リソースをAngularの遅延チャンクとして読み込む。
 * 起動済みWatchでもソース変更だけで反映でき、外部CDNやassetsコピー設定に依存しない。
 */
export async function ensureVditorRuntime(): Promise<ITips> {
  runtimePromise ??= Promise.all([
    import('vditor/dist/js/lute/lute.min.js'),
    import('vditor/dist/js/icons/ant.js'),
    import('vditor/dist/js/i18n/ja_JP.js'),
  ]).then(() => window.VditorI18n);

  const i18n = await runtimePromise;
  // Vditorは要素IDだけで動的ロード済みかを判定する。destroy()後はアイコン側が消えるため毎回補う。
  ensureLoaderMarker('vditorLuteScript');
  ensureLoaderMarker('vditorIconScript');
  return i18n;
}
